import { Component } from "react";

class ErrorList extends Component {
	render() {
		const { errors, className } = this.props;

		if (!errors) {
			return <span />;
		}

		const attr = {
			className: "error-list"
		};

		if (className) {
			attr.className += " " + className;
		}

		return (
			<ul {...attr}>
				{Object.keys(errors).map((property, index) => {
					return <li key={index}>{errors[property]}</li>;
				})}
			</ul>
		);
	}
}

export default ErrorList;
